import { render } from "./StoragePackages.vue?vue&type=template&id=c542ca46&scoped=true"
import script from "./StoragePackages.vue?vue&type=script&lang=js"
export * from "./StoragePackages.vue?vue&type=script&lang=js"

import "./StoragePackages.vue?vue&type=style&index=0&id=c542ca46&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c542ca46"]])

export default __exports__